module.exports = __webpack_public_path__ + "img/silder_02.17239431.jpg";